import { LOGIN_SUCCEEDED } from '../actions/auth';

import { UPDATE_STUDENT_PROFILE_SUCCEEDED } from '../actions/currentUser';

const initialState = {
  phrases: [],
  currentLocale: 'en',
};

export default function localeReducer(state = initialState, action) {
  const { payload, type } = action;
  switch (type) {
    case LOGIN_SUCCEEDED:
    case UPDATE_STUDENT_PROFILE_SUCCEEDED:
      const localeInfo = payload.locale_info;
      if (localeInfo && state.currentLocale !== localeInfo.locale) {
        return {
          ...state,
          currentLocale: localeInfo.locale,
          phrases: localeInfo.messages,
        };
      } else {
        return state;
      }
    default:
      return state;
  }
}
